import { GoogleAnalytics } from '@/analytics/providers/GoogleAnalytics.js';

// Side load some external scripts as ad blocks can sometimes strip them
// Causing the main index.jsx to get blocked
//
// We can live with Google Analytics not loading,
// but we can't live with the main app not working and kids not understanding why
let _ = new GoogleAnalytics();
